import { useContext } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { AppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import { MenuItem } from '../models/models';

interface SCNavbarProps {
  backToScientificCommitee?: string;
  section?: string;
  scientificCommittee?: string;
}

export const SCNavbar = ({ backToScientificCommitee, section, scientificCommittee }: SCNavbarProps) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const menu: MenuItem[] = appContext?.state.data?.menu || [];

  const hasEventsSection = menu.some(item => item.link === 'events');

  const menuItem = (label: string, link: string, index: number, submenu?: MenuItem[] ) => (
    <>
    
    {submenu && submenu.length > 0 ? (
      <NavDropdown key={index} title={label} id="basic-nav-dropdown">
        {submenu.map((item, index) => (
          <NavDropdown.Item key={index} href={`#${item.link}`}>{item.label}</NavDropdown.Item>
        ))}
      </NavDropdown>
    ) : (
      <Nav.Link key={index} onClick={() => navigate(`/${scientificCommittee}${link !== 'home' ? `#${link}` : ''}`)} href={`#${link}`}>
        {label}
      </Nav.Link>
    )}
    </>
  );

  const backToScientificCommiteePath = backToScientificCommitee && `/${backToScientificCommitee}${section ? `#${section}` : ''}`;

  const handleNavigate = (path: string) => {
    navigate(path); 
  };

  const handleNavigateEvents = () => {
    navigate(`/${scientificCommittee}/past-events`);
    window.scrollTo(0, 0);
  };

  return (
    <Navbar className='sc-navbar' bg="primary" variant="dark" expand="lg">
      <Container>
        <Nav className="me-auto sc-navbar-horizontal">
        {backToScientificCommiteePath ? (
          <Nav.Link onClick={() => handleNavigate(backToScientificCommiteePath)}>
          <svg xmlns="http://www.w3.org/2000/svg" className='me-2' width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
          </svg> Back to Homepage
          </Nav.Link>
        ) : (
              <>
              {menu.map((item, index) => menuItem(item.label, item.link, index, item.submenu))}
              {hasEventsSection &&  (
              <Nav.Link key="events" onClick={handleNavigateEvents}>
                Past events
              </Nav.Link>
              )}
              </>
        )}
        
        </Nav>
      </Container>
    </Navbar>
  );
};
